import { atom } from 'recoil';
import { IComanda } from '../../commons/types/crm';


export const comandaAtom = atom<IComanda[]>({
  key: 'comanda',
  default: [] as IComanda[],
});
